'use strict';

var $Object = require('es-object-atoms');

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;



/*****************
 ** WEBPACK FOOTER
 ** ./~/get-proto/Object.getPrototypeOf.js
 ** module id = 634
 ** module chunks = 0
 **/